// extracted by mini-css-extract-plugin
export var card = "_4l-0";
export var content = "_4l-1";
export var contentLoading = "_4l-2";